import React from "react";
import "./Twitter.css";
import { payoneerLink } from "../../Constants";
export default function MyTwitter() {
  return (
    <div className="open-twitter">
      <a href={payoneerLink} target="_blank" />
    </div>
  );
}
